export default __webpack_public_path__ + "static/media/pushDown.649bd86a.png";